import { Link } from "react-router-dom";
import { BRAND } from "../lib/assets";

const Footer = () => {
  return (
    <footer
      className="border-t-2 border-black mt-32 pt-20"
      data-testid="site-footer"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src={BRAND.logo}
                alt="UPRCSE - Design & Brand Consultant"
                className="h-20 md:h-24 w-auto object-contain"
              />
            </div>
            <p
              className="text-black/75 text-base md:text-lg max-w-md leading-relaxed"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Branding, design and execution - delivered as one continuous
              system. Not a vendor. A full-stack brand execution partner.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="mono-label mb-5">Index</div>
            <ul className="space-y-3 text-black">
              <li>
                <Link to="/" className="ghost-link" data-testid="footer-link-uprcse">
                  Uprcse
                </Link>
              </li>
              <li>
                <Link to="/founder" className="ghost-link" data-testid="footer-link-founder">
                  Founder
                </Link>
              </li>
              <li>
                <Link to="/connect" className="ghost-link" data-testid="footer-link-connect">
                  Connect
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="mono-label mb-5">Studio - Mumbai</div>
            <address
              className="not-italic text-black/80 leading-relaxed"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              UPRCSE
              <br />
              1104 Bluebell, Hubtown Gardenia,
              <br />
              Gaurav Enclave Road, Mira Road,
              <br />
              Mumbai 401 107.
            </address>
            <div className="mt-5 space-y-2">
              <a
                href="mailto:info@uprcse.com"
                className="block text-black hover:text-[#AE519F] transition-colors"
                data-testid="footer-email"
                style={{ fontFamily: "JetBrains Mono, monospace", fontSize: "13px" }}
              >
                info@uprcse.com
              </a>
              <a
                href="tel:+919892510233"
                className="block text-black hover:text-[#AE519F] transition-colors"
                data-testid="footer-phone"
                style={{ fontFamily: "JetBrains Mono, monospace", fontSize: "13px" }}
              >
                +91 98925 10233
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Edge-to-edge thick divider above the copyright row */}
      <div className="border-t-2 border-black" aria-hidden />

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 pt-8 pb-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="mono-label" data-testid="footer-copyright">
            © {new Date().getFullYear()} UPRCSE - All systems aligned.
          </div>
          <div className="mono-label">Mumbai · India</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
